var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJava(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 200,
    viewBox: "0 0 155 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3193 154.608C50.3193 154.608 42.3544 159.045 55.988 160.546C72.5051 162.351 80.9462 162.092 99.1483 158.792C99.1483 158.792 103.934 161.666 110.617 164.156C69.8135 180.906 18.27 163.185 50.3193 154.608Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3333 132.751C45.3333 132.751 36.3998 139.085 50.0436 140.437C67.6875 142.18 81.621 142.323 105.732 137.876C105.732 137.876 109.067 141.114 114.311 142.885C64.9766 156.702 10.0276 143.975 45.3333 132.751Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3669 95.6734C97.4211 106.76 84.7254 116.737 84.7254 116.737C84.7254 116.737 110.254 104.114 98.5297 88.3075C87.5799 73.5676 79.1822 66.2427 124.642 40.9907C124.642 40.9907 53.2856 58.0601 87.3669 95.6728",
    fill: "#E76F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.333 170.775C141.333 170.775 147.227 175.427 134.841 179.026C111.289 185.86 36.8137 187.923 16.1246 179.298C8.68775 176.2 22.6346 171.899 27.0214 170.996C31.5965 170.046 34.2114 170.223 34.2114 170.223C25.9405 164.643 -19.2481 181.181 11.258 185.917C94.4519 198.84 162.912 180.099 141.333 170.775Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1491 110.104C54.1491 110.104 16.267 118.723 40.7346 121.852C51.0652 123.177 71.6596 122.877 90.8429 121.337C106.521 120.071 122.263 117.378 122.263 117.378C122.263 117.378 116.735 119.645 112.735 122.261C74.2661 131.952 -0.0497322 127.444 21.3448 117.531C39.4383 109.154 54.1497 110.104 54.1497 110.104",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.107 146.487C161.213 127.023 143.132 108.319 130.511 110.839C127.418 111.455 126.039 111.99 126.039 111.99C126.039 111.99 127.187 110.267 129.38 109.521C154.347 101.114 173.549 134.317 121.321 147.468C121.321 147.468 121.926 146.95 122.107 146.487Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5297 0.214445C98.5297 0.214445 120.187 20.9659 77.9885 52.874C44.1498 78.4705 70.2722 93.0647 77.9746 109.739C58.2222 92.6699 43.7262 77.6433 53.4515 63.6584C67.7248 43.1283 107.268 33.1751 98.5297 0.213867",
    fill: "#E76F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9922 199.228C95.5291 201.53 153.171 197.952 154.536 180.939C154.536 180.939 151.912 187.389 123.514 192.511C91.4754 198.285 51.9608 197.611 28.524 193.91C28.5247 193.91 33.3218 197.713 57.9928 199.228",
    fill: "#5382A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154.503,
    height: 200,
    fill: "white",
    transform: "translate(0.494385)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/java.e2a550fe870f9ca420f513b19e752fbe.svg";
export { ForwardRef as ReactComponent };